import React from 'react'
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/ui/breadcrumb'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/ui/dropdown-menu'
import { checkIsEqueal } from '@/shared/routing'
import { usePathname } from '@/shared/config/i18n'

// Define the type for breadcrumb items and dropdown items
export interface BreadcrumbsSubItem {
  label: string
  path: string
}

export interface BreadcrumbsItemType {
  label: React.ReactNode
  path?: string
  subItems?: BreadcrumbsSubItem[]
}

export interface BreadcrumbsProps {
  items: BreadcrumbsItemType[]
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  const pathname = usePathname()
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isActive = checkIsEqueal(pathname, item.path || '')
          const isLastItem = index === items.length - 1
          const isSubItems = (item.subItems || [])?.length > 0
          return (
            <React.Fragment key={index}>
              <BreadcrumbItem>
                {isSubItems ? (
                  <DropdownMenu>
                    <DropdownMenuTrigger className="flex items-center gap-1">
                      <BreadcrumbEllipsis className="h-4 w-4" />
                      <span className="sr-only">Toggle menu</span>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start">
                      {item.subItems?.map((sub, index) => (
                        <DropdownMenuItem key={index}>
                          <BreadcrumbLink href={sub.path}>{sub.label}</BreadcrumbLink>
                        </DropdownMenuItem>
                      ))}
                    </DropdownMenuContent>
                  </DropdownMenu>
                ) : isActive ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink href={item.path || ''}>{item.label}</BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLastItem && <BreadcrumbSeparator />}
            </React.Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
